/** 主站 / 页脚共享绝对链接（无业务文案，避免 footer ↔ sea 循环依赖） */
export const GCSA_MAIN_ORIGIN = 'https://gcsa.org';
export const GCSA_MEDIA_ORIGIN = 'https://media.gcsa.org';
export const GCSA_CONTACT_EMAIL = 'contact@gcsa.com';
export const GCSA_X_URL = 'https://x.com/gcsa_org';
export const GCSA_TELEGRAM_URL = 'https://t.me/GCSAofficial';
